module.exports = __webpack_public_path__ + "img/15.390760ad.jpg";